import { render, staticRenderFns } from "./MinigamesTournamentPage.vue?vue&type=template&id=5878f0fa&scoped=true"
import script from "./MinigamesTournamentPage.vue?vue&type=script&lang=js"
export * from "./MinigamesTournamentPage.vue?vue&type=script&lang=js"
import style0 from "./MinigamesTournamentPage.vue?vue&type=style&index=0&id=5878f0fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5878f0fa",
  null
  
)

export default component.exports